// Import individual scripts rather than importing ALL components
// import 'bootstrap/js/dist/util';
// or
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';



// WEBPACK FOOTER //
// ./scripts/autoload/_bootstrap.js